import React from "react";
import { FormCheck, InputGroup } from "react-bootstrap";

import classes from "./Checkbox.module.css";

interface Props {
  label: string;
  id: string;
  defaultChecked?: boolean;
  onChange: () => void;
  checked?: boolean;
  name?: string;
  disabled?: boolean;
}

const checkbox: React.FunctionComponent<Props> = (props) => {
  const { label, id, defaultChecked, onChange, checked, name, disabled } = {
    ...props,
  };
  return (
    <InputGroup className={classes.inputGroup}>
      <FormCheck
        type="checkbox"
        id={id}
        className={classes.checkbox}
        label={label}
        defaultChecked={defaultChecked}
        onChange={onChange}
        checked={checked}
        name={name}
        disabled={disabled}
      />
    </InputGroup>
  );
};
export default checkbox;
